import { z } from 'zod'

// ISSUE #8: Executor が job 実行中の artifact (diff, ログ, スクショ) を
// Worker 経由で R2 にアップロードするための request schema。
//
// `filename` はクライアント表示用 (R2 key の末尾にも使うが、parent dir
// が `jobs/<job_id>/` 配下に固定されるためパストラバーサルを防ぐ
// バリデーションは Worker 側 (resolveFilename) でも行う)。
//
// `content_type` は HMAC token に焼き込み、`PUT /api/uploads/:token`
// での R2 put 時に `Content-Type` として使う。値は再アップロード時に
// 変更できない (token に bind されている) ため client は事前申告のみ。
export const CreateUploadRequestSchema = z.object({
  filename: z.string().min(1).max(255),
  content_type: z.string().min(1).max(255),
})
export type CreateUploadRequest = z.infer<typeof CreateUploadRequestSchema>

export const CreateUploadResponseSchema = z.object({
  upload_url: z.string(),
  r2_key: z.string(),
})
export type CreateUploadResponse = z.infer<typeof CreateUploadResponseSchema>

export const UploadCompleteResponseSchema = z.object({
  r2_key: z.string(),
  size: z.number().int().nonnegative(),
})
export type UploadCompleteResponse = z.infer<typeof UploadCompleteResponseSchema>
